import { H2, H3, Meta, PrimaryButton, SubBody } from '@rikstv/shared-components';
import { FC } from 'react';
import { FlexBox } from '~/components/shared/layout/FlexBox';

import classNames from 'classnames';
import { captureUXEvent } from '~/analytics/productAnalytics';
import { SubscriptionFeatures } from '~/components/shared/subscription-comparison/overview-list/SubscriptionFeatures';
import { ComparableSubscription } from '~/models/subscription-comparison/ComparableSubscriptions';
import classes from '../InternetOfferSubPage.module.css';
import { useInternetFlowStore } from '../useInternetStore';

export const TvProductCard: FC<{ subscription: ComparableSubscription }> = ({ subscription }) => {
  const doSelect = useInternetFlowStore(s => s.setSelectedSubscription);
  const isSelected = useInternetFlowStore(s => s.selectedSubscription?.name === subscription.name);
  
  const onSelectPackage = () => {
    captureUXEvent('rtv_sales_select_internet_subscription', { productName: subscription.name });
    doSelect(subscription);
  };

  return (
    <div className={classNames(classes.packageCard, { [classes.selected]: isSelected })}>
      <FlexBox direction="column" alignItems={'center'} gap={'24px'}>
        {/* title */}
        <H2 lookLike="title-3">{subscription.name}</H2>
        {/* price */}
        <div>
          <FlexBox alignItems={'end'}>
            <H3 lookLike="title-2">
              {subscription.currentPrice},-
            </H3>
            <SubBody>/mnd. i 12 mnd*</SubBody>
          </FlexBox>
          <Meta
            as="div"
            className={classes.centerText}
          >
            Originalpris {subscription.originalPrice},- /mnd
          </Meta>
        </div>
        <SubBody className={classes.cardDescription}>Passer for deg som vil ha en rimelig TV-pakke med de mest populære kanalene.</SubBody>
        {/* actions */}
        <PrimaryButton disabled={isSelected} style={{width: '100%', justifyContent: 'space-around'}} data-testid={`btn-select-${subscription.name}`} onClick={onSelectPackage}>
          {isSelected ? 'Valgt' : 'Velg'}
        </PrimaryButton>
          
        {/* features */}
        <SubscriptionFeatures className={classes.cardFeatures} subscription={subscription} />
      </FlexBox>
    </div>
  );
};
